import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  Divider,
  CircularProgress,
  TextField,
  Button,
  Snackbar,
  Alert,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../../../Config/api";

const Handoversession = ({
  data,
  eveId,
  sessionId,
  requestID,
  onClose,
  getProfRequest,
  mode,
}) => {
  // const port = process.env.REACT_APP_API_KEY;
  const accessToken = localStorage.getItem("token");

  const [handoverData, setHandoverData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [remark, setRemark] = useState("");

  // Snackbar states
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success", // "success" | "error" | "warning" | "info"
  });

  const navigate = useNavigate();

  useEffect(() => {
    if (data) {
      setHandoverData([data]);
    }
  }, [data]);

  // ✅ Snackbar helper
  const showSnackbar = (message, severity = "success") => {
    setSnackbar({ open: true, message, severity });
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  // ✅ Approve handler
const handleApproveHandover = async () => {
  if (!remark.trim()) {
    showSnackbar("Please enter approval remark before submitting!", "warning");
    return;
  }

  if (!eveId) {
    showSnackbar("Event ID not found!", "error");
    return;
  }

  try {
    setLoading(true);

    const res = await fetch(
      `${API_URL}/web/agg_hhc_srv_req_prof_allocate/${eveId}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (!res.ok) throw new Error("Failed to fetch allocation data");

    const data = await res.json();

    showSnackbar("Handover request approved successfully!", "success");

    setTimeout(() => {
      navigate("/viewservice", {
        state: {
          patientID: data.patient_details.agg_sp_pt_id,
          callerID: data.caller_details.caller_id,
          eventPlanID: data.POC?.[0]?.eve_poc_id,
          eventID: data.Event_ID,
          casehandover: true,
          flag: 5,
          handoverData: handoverData[0],
          approval_remark: remark,
          sessionId,
          requestID,
          mode,
        },
      });

      if (onClose) onClose();
      if (getProfRequest) getProfRequest();
 
    }, 2000);
  } catch (error) {
    console.error(error);
    showSnackbar("Failed to approve handover request.", "error");
    setLoading(false); 
  }
};



  //  Reject handler
 const handleRejectHandover = async () => {
  if (!remark.trim()) {
    showSnackbar("Please enter your rejection remark before submitting.", "warning");
    return;
  }

  const payload = { rejected_remark: remark };

  try {
    setLoading(true);
    const reqID = handoverData[0]?.req_id;

    const response = await fetch(`${API_URL}/web/handover_request_reject/${reqID}/`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) throw new Error("Failed to reject handover request");

    const result = await response.json();
    console.log("✅ Handover rejected successfully:", result);

    // ✅ Show snackbar immediately
    showSnackbar("Handover request rejected successfully!", "success");

    // ✅ Keep button disabled while snackbar is visible (2 seconds delay)
    setTimeout(() => {
      if (onClose) onClose();
      if (getProfRequest) getProfRequest();
      setLoading(false); // re-enable button after modal closes
    }, 2000);
  } catch (error) {
    console.error("❌ Error rejecting handover:", error);
    showSnackbar("Failed to reject handover request. Please try again.", "error");
    setLoading(false);
  }
};


 

  if (!handoverData.length) {
    return (
      <Typography sx={{ mt: 2, textAlign: "center" }}>
        No handover details available.
      </Typography>
    );
  }

  return (
    <>
    <Box sx={{  overflowY: "auto", maxHeight: "70vh", pr: 1 }}>
  {handoverData.map((item, index) => (
    <Box
      key={index}
      sx={{
        background: "#F8F9FF",
        borderRadius: "12px",
        p: 2.5,
        mt: 0.5,
        boxShadow: "0px 4px 12px rgba(0,0,0,0.08)",
      }}
    >
      {/* ===== BASIC INFO ===== */}
      <Grid container justifyContent="space-between" sx={{ mb: 1 }}>
        <Typography color="text.secondary">Event Code</Typography>
        <Typography fontWeight={500}>
          {item.eve_id?.event_code || "-"}
        </Typography>
      </Grid>

      <Grid container justifyContent="space-between" sx={{ mb: 1 }}>
        <Typography color="text.secondary">Service</Typography>
        <Typography fontWeight={500}>
          {item.epoc_id?.srv_id?.service_title || "-"}
        </Typography>
      </Grid>

      <Grid container justifyContent="space-between" sx={{ mb: 1 }}>
        <Typography color="text.secondary">Professional Name</Typography>
        <Typography fontWeight={500}>
          {item.prof_name || "-"}
        </Typography>
      </Grid>

      <Grid container justifyContent="space-between" sx={{ mb: 1 }}>
        <Typography color="text.secondary">Phone</Typography>
        <Typography fontWeight={500}>
          {item.prof_no || "-"}
        </Typography>
      </Grid>

      {/* ===== HANDOVER SESSIONS ===== */}
      <Box sx={{ mt: 2 }}>
        <Typography color="text.secondary" sx={{ mb: 0.5 }}>
          Hand-over Sessions
        </Typography>

        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
          {item.hand_over_sess?.length ? (
            item.hand_over_sess.map((date, i) => (
              <Box
                key={i}
                sx={{
                  px: 1.5,
                  py: 0.5,
                  backgroundColor: "#E3F2FD",
                  borderRadius: "20px",
                  fontSize: "12px",
                  fontWeight: 500,
                }}
              >
                {date}
              </Box>
            ))
          ) : (
            <Typography>-</Typography>
          )}
        </Box>
      </Box>

      {/* ===== DO'S ===== */}
      <Box sx={{ mt: 2 }}>
        <Typography color="text.secondary" sx={{ mb: 0.5 }}>
 What to Do
        </Typography>
        <Box
          sx={{
            backgroundColor: "#fff",
            p: 1.5,
            borderRadius: "8px",
            maxHeight: "120px",
            overflowY: "auto",
            fontSize: "14px",
            lineHeight: 1.6,
            whiteSpace: "pre-line",
            border: "1px solid #E0E0E0",
          }}
        >
          {item.dos || "-"}
        </Box>
      </Box>

      {/* ===== DON'TS ===== */}
      <Box sx={{ mt: 2 }}>
        <Typography color="text.secondary" sx={{ mb: 0.5 }}>
    what Not to Do
        </Typography>
        <Box
          sx={{
            backgroundColor: "#fff",
            p: 1.5,
            borderRadius: "8px",
            maxHeight: "120px",
            overflowY: "auto",
            fontSize: "14px",
            lineHeight: 1.6,
            whiteSpace: "pre-line",
            border: "1px solid #E0E0E0",
          }}
        >
          {item.donts || "-"}
        </Box>
      </Box>

      <Divider sx={{ my: 2 }} />

      {/* ===== REMARK INPUT ===== */}
      <Box sx={{ mt: 1 }}>
        <Typography sx={{ fontWeight: 500, mb: 0.5, color: "text.secondary" }}>
          {mode === "approve"
            ? "Handover Approval Remark"
            : "Handover Rejection Remark"}
        </Typography>

        <TextField
          fullWidth
          multiline
          rows={3}
          placeholder={
            mode === "approve"
              ? "Write your approval remark..."
              : "Write your rejection remark..."
          }
          value={remark}
          onChange={(e) => setRemark(e.target.value)}
          sx={{
            backgroundColor: "#fff",
            borderRadius: "8px",
            "& .MuiOutlinedInput-root": {
              borderRadius: "8px",
            },
          }}
        />
      </Box>

      {/* ===== ACTION BUTTON ===== */}
      <Box sx={{ textAlign: "center", mt: 2 }}>
        <Button
          variant="contained"
          disabled={loading || !remark.trim()}
          onClick={
            mode === "approve"
              ? handleApproveHandover
              : handleRejectHandover
          }
          sx={{
            backgroundColor: mode === "approve" ? "#2e7d32" : "#d32f2f",
            textTransform: "capitalize",
            borderRadius: "8px",
            px: 4,
            py: 1,
            "&:hover": {
              backgroundColor:
                mode === "approve" ? "#1b5e20" : "#b71c1c",
            },
          }}
        >
          {loading ? (
            <>
              <CircularProgress size={20} sx={{ color: "#fff", mr: 1 }} />
              {mode === "approve" ? "Approving..." : "Rejecting..."}
            </>
          ) : mode === "approve" ? (
            "Approve Handover"
          ) : (
            "Reject Handover"
          )}
        </Button>
      </Box>
    </Box>
  ))}
</Box>

{/* ===== SNACKBAR ===== */}
<Snackbar
  open={snackbar.open}
  autoHideDuration={3000}
  onClose={handleCloseSnackbar}
  anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
>
  <Alert
    onClose={handleCloseSnackbar}
    severity={snackbar.severity}
    sx={{ width: "100%" }}
  >
    {snackbar.message}
  </Alert>
</Snackbar>
{loading && (
  <Box
    sx={{
      position: "absolute",
      inset: 0,
      backgroundColor: "rgba(255,255,255,0.6)",
      zIndex: 10,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "12px",
    }}
  >
    <CircularProgress />
  </Box>
)}

    </>
  );
};

export default Handoversession;
